"use strict";

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var MediatedLinkedRdfSourcesAsyncRdfIterator_1 = require("./MediatedLinkedRdfSourcesAsyncRdfIterator");
/**
 * A lazy quad source that creates {@link MediatedLinkedRdfSourcesAsyncRdfIterator} instances when matching quads.
 *
 * @see MediatedLinkedRdfSourcesAsyncRdfIterator
 */


var MediatedQuadSource =
/*#__PURE__*/
function () {
  function MediatedQuadSource(cacheSize, context, firstUrl, forceSourceType, mediators) {
    _classCallCheck(this, MediatedQuadSource);

    this.cacheSize = cacheSize;
    this.context = context;
    this.firstUrl = firstUrl;
    this.forceSourceType = forceSourceType;
    this.mediators = mediators;
  }

  _createClass(MediatedQuadSource, [{
    key: "matchLazy",
    value: function matchLazy(subject, predicate, object, graph) {
      if (subject instanceof RegExp || predicate instanceof RegExp || object instanceof RegExp || graph instanceof RegExp) {
        throw new Error("MediatedQuadSource does not support matching by regular expressions.");
      }

      var it = new MediatedLinkedRdfSourcesAsyncRdfIterator_1.MediatedLinkedRdfSourcesAsyncRdfIterator(this.cacheSize, this.context, this.forceSourceType, subject, predicate, object, graph, this.firstUrl, this.mediators);

      if (!this.sourcesState) {
        it.setSourcesState();
        this.sourcesState = it.sourcesState;
      } else {
        it.setSourcesState(this.sourcesState);
      }

      return it;
    }
  }, {
    key: "match",
    value: function match(subject, predicate, object, graph) {
      return this.matchLazy(subject, predicate, object, graph);
    }
  }]);

  return MediatedQuadSource;
}();

exports.MediatedQuadSource = MediatedQuadSource;